import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FilterList from 'components/FilterList';
import moment from 'moment';
import text from './AuditList.page.translation';

export class AuditFilter extends Component {
  constructor(props) {
    super(props);
    const {
      intl: { formatMessage },
    } = props;
    this.state = {
      filterOption: [
        {
          value: 'employee_name',
          label: formatMessage(text.label.employee),
          visible: false,
          typeForm: 'string',
          prefixValue: `${formatMessage(text.label.employee)} is`,
        },
        {
          value: 'company_name',
          label: formatMessage(text.label.company),
          visible: false,
          typeForm: 'string',
          prefixValue: `${formatMessage(text.label.company)} is`,
        },
        {
          value: 'rangeDate',
          label: formatMessage(text.label.date),
          visible: false,
          prefixValue: `${formatMessage(text.label.date)} from`,
          typeForm: 'dateRangePicker',
          ranges: {
            Today: [moment().startOf('day'), moment().endOf('day')],
            'This Week': [moment().startOf('week'), moment().endOf('week')],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
          },
          showTime: true,
          withDeselect: true,
          onDeselect: {
            callback: this._dateRangePickerOnDeselect,
          },
          formatingValue: this._dateRangePickerFormatingValue,
          customMasking: this._rangeMasking,
        },
        {
          value: 'service',
          label: formatMessage(text.label.module),
          visible: false,
          typeForm: 'string',
          prefixValue: `${formatMessage(text.label.module)} is`,
        },
        {
          value: 'operation_type',
          label: formatMessage(text.label.action),
          visible: false,
          typeForm: 'radio',
          listOption: [
            { value: 'CREATE', label: 'CREATE' },
            { value: 'READ', label: 'READ' },
            { value: 'UPDATE', label: 'UPDATE' },
            { value: 'DELETE', label: 'DELETE' },
            { value: 'DOWNLOAD', label: 'DOWNLOAD' },
          ],
          prefixValue: `${formatMessage(text.label.action)} is`,
        },
      ],
      openDropdown: false,
      viewValue: [],
    };
  }

  _rangeMasking = input => `${input[0]} to ${input[1]}`;

  _dateRangePickerFormatingValue = (checkType, input) => {
    const newFormatValue = [{ param: 'rangeDate', valParam: input }];
    return newFormatValue;
  };

  _dateRangePickerOnDeselect = (selVal, selOpt) => {
    selVal.splice(selVal.findIndex(e => e.param.includes('rangeDate')), 1);
    selOpt.splice(selOpt.findIndex(e => e.includes('date')), 1);
  };

  _filterStateHandler = (key, additionalParams) => {
    this.setState(state => {
      state.filterOption[key].visible = additionalParams.visible;
      return { filterOption: state.filterOption };
    });
  };

  // Function to handle Special Condition in handleChangeSelect Function
  _callbackChangeSelect = (formType, selectedValue) => {
    if (formType === 'rangeDate') {
      selectedValue.push({ param: 'rangeDate', valParam: '' });
    }
    return selectedValue;
  };

  // Function to handle Special Condition in handleCancelFilter Function
  _callbackCancelFilter = (key, selectedValue = null) => {
    const {
      intl: { formatMessage },
    } = this.props;
    if (key === formatMessage(text.label.date)) {
      selectedValue.splice(
        selectedValue.findIndex(e => e.param === 'rangeDate'),
        1,
      );
    }
    return selectedValue;
  };

  // Function to handle Special Condition in onDeselect Function
  _callbackOnDeselect = checkValue => {
    const {
      intl: { formatMessage },
    } = this.props;
    let getKey;
    if (checkValue === formatMessage(text.label.date)) {
      getKey = _.findKey(this.state.filterOption, {
        label: _.startCase(checkValue),
      });
    }
    return getKey;
  };

  // Function to set state in this file
  _handleChildrenUpdateState = (val, callback = () => null) => {
    this.setState(val, callback);
  };

  _callHandleApiFilter = (value = 1) => {
    this.props.handleApiFilter(value);
  };

  render() {
    return (
      <FilterList
        filterList={this.state.filterOption}
        viewValue={this.state.viewValue}
        openDropdown={this.state.openDropdown}
        selectedOption={this.props.selectedOption}
        selectedValue={this.props.selectedValue}
        filterStateHandler={this._filterStateHandler}
        callHandleApiFilter={this._callHandleApiFilter}
        handleChildrenUpdateState={this._handleChildrenUpdateState}
        handleParentUpdateState={this.props.handleUpdateState}
        handleChangePage={this.props.handleChangePage}
        callbackChangeSelect={this._callbackChangeSelect}
        callbackCancelFilter={this._callbackCancelFilter}
        callbackOnDeselect={this._callbackOnDeselect}
      />
    );
  }
}

AuditFilter.propTypes = {
  intl: PropTypes.object.isRequired,
  handleUpdateState: PropTypes.func.isRequired,
  handleApiFilter: PropTypes.func.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  selectedValue: PropTypes.array,
  selectedOption: PropTypes.array,
};

export default AuditFilter;
